import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const FlashCardsStepOneExtraCollections = ({
  flashCardsStepOneExtraCollections,
  flashCardsStepOneExtraCurrency,
  getCollections,
  hasLoaded,
  pageCount,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="flash-cards-collections-container--step-one-extra"
      collectionsPath={paths.FLASH_CARDS_STEP_ONE_EXTRA}
      currency={flashCardsStepOneExtraCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={flashCardsStepOneExtraCollections}
      levelsPath={paths.FLASH_CARDS_STEP_ONE_EXTRA_LEVELS}
      pageCount={pageCount}
      student={student}
      title={messages.game.flashCards}
    />
  );
};

FlashCardsStepOneExtraCollections.propTypes = {
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  flashCardsStepOneExtraCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  flashCardsStepOneExtraCurrency: PropTypes.shape({}).isRequired,
  pageCount: PropTypes.number.isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.flashCardsStepOneExtraCollections.getHasLoaded(state),
  flashCardsStepOneExtraCurrency: selectors.flashCardsStepOneExtraCollections.getCurrencyData(
    state
  ),
  flashCardsStepOneExtraCollections: selectors.flashCardsStepOneExtraCollections.getCollectionsData(
    state
  ),
  pageCount: selectors.flashCardsStepOneExtraCollections.getPageCount(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.flashCardsStepOneExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(FlashCardsStepOneExtraCollections);
